import React, { FC, PropsWithChildren } from 'react';
import { ProductLogo } from '.';

export interface HeaderProps {
    mainTitle: string;
    subTitle?: string;
}

export const Header: FC<PropsWithChildren<HeaderProps>> = (
    props: PropsWithChildren<HeaderProps>
) => {
    const {mainTitle, subTitle, children} = props;
    return (
        <div className="layout-header">
            <ProductLogo />
            <h1>
                <span className="layout-header-title">{mainTitle}</span>
                {subTitle && (
                    <span className="layout-header-subtitle">
                        {subTitle}
                    </span>
                )}
            </h1>

            <div className="layout-header-content">{children}</div>
        </div>
    );
};
